import { Chip } from "@mui/material";
import CustomTable from "components/CustomTable";
import CustomText from "components/typography/CustomText";
import moment from "moment";
import ExportReactCSV from "components/ExportReactCSV";
import React from "react";

export default function QueueTable({
  data = [],
  tab = {},
  onClick = () => {},
}) {
  const headers = [
    { label: "name", key: "name" },
    { label: "email", key: "email" },
    { label: "Date Joined", key: "date_joined" },
    { label: "Email Sent", key: "email_sent" },
  ];

  const queue = () => {
    return data?.map((row) => ({
      name: row?.name ?? "",
      email: row?.email,
      date_joined: moment(row.created_at).format("DD, MMMM YYYY"),
      email_sent: Boolean(row.flag) ? "Yes" : "No",
    }));
  };
  return (
    <div>
      <CustomTable
        data={data}
        pageCount={20}
        height={650}
        toolbar={
          <div className="p-4 border-b border-white-gray flex justify-between items-center">
            <CustomText variant="h6" bold={600}>
              Queue
            </CustomText>
            <ExportReactCSV
              csvHeaders={headers}
              csvData={queue()}
              fileName={`queueList.csv`}
            />
          </div>
        }
        columns={[
          { label: "NAME", selector: "name" },
          { label: "EMAIL", selector: "email" },
          {
            label: "DATE JOINED",
            selector: "joined",
            sortValue: (row) => moment(row.created_at).unix(),
            cell: (row) => (
              <CustomText className="py-2" variant="body2">
                {moment(row.created_at).format("DD, MMMM YYYY")}
              </CustomText>
            ),
          },
          {
            label: "Email Type",
            selector: "flag",
            cell: (row) => (
              <Chip
                color={
                  row?.status === "0"
                    ? "primary"
                    : row?.status === "1"
                    ? "success"
                    : "warning"
                }
                label={
                  row?.status === "0"
                    ? "Pending"
                    : row?.status === "1"
                    ? "Invite Sent"
                    : "Expiration"
                }
              />
            ),
          },
          tab === "0"
            ? {
                label: "",
                selector: "actions",
                cell: (row) => (
                  <Chip
                    color="primary"
                    label="Send Invite"
                    onClick={() => onClick(row)}
                  />
                ),
              }
            : {},
        ]}
      />
    </div>
  );
}
